const dismissBannerBtn = document.getElementById('dismiss-banner');
const mainHeader = document.getElementById("main-header");
const banner = document.getElementById('smartBanner');

const showBanner = () => {
    document.body.classList.add("with-smart-banner");
    mainHeader.classList.add("with-smart-banner");
    banner.classList.remove("hidden");
}

const hideBanner = () => {
    document.body.classList.remove("with-smart-banner");
    mainHeader.classList.remove("with-smart-banner");
    banner.classList.add("hidden");
}

const toggleIosBanner = (show = false) => {
    const iosBtn = document.getElementById("ios-app-btn");
    const categoryText = document.getElementById("app-category");

    if (show) {
        iosBtn.classList.remove("hidden");

        if (navigator.language.includes("en")) {
            iosBtn.textContent = "Get";
            categoryText.textContent = "Medical"
        }

        showBanner()
    } else {
        iosBtn.classList.add("hidden");
        hideBanner()
    }
}

const toggleAndroidBanner = (show = false) => {
    const androidBtn = document.getElementById("android-app-btn");
    const categoryText = document.getElementById("app-category");

    if (show) {
        androidBtn.classList.remove("hidden");

        if (navigator.language.includes("en")) {
            androidBtn.textContent = "Get";
            categoryText.textContent = "Medical"
        }

        showBanner()
    } else {
        androidBtn.classList.add("hidden");
        hideBanner()
    }
}

const setCookie = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

const bannerDismissed = getCookie('smart-banner-dismissed') !== null;
const userAgent = navigator.userAgent || navigator.vendor || window.opera;

if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)) {
    toggleIosBanner(!bannerDismissed)
} else if (/Android/i.test(navigator.userAgent)) {
    toggleAndroidBanner(!bannerDismissed)
} else {
    toggleIosBanner(false)
    toggleAndroidBanner(false)
}

dismissBannerBtn.addEventListener("click", () => {
    setCookie('smart-banner-dismissed', 'true', "400");
    document.body.classList.remove("with-smart-banner");
    hideBanner();
})

